import { convertToMapById } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";

export const CONTRACT_SELECTED = 'CONTRACT_SELECTED';
export const CONTRACT_VARIANT_SELECTED = 'CONTRACT_VARIANT_SELECTED';
export const GET_CONTRACTS = 'GET_CONTRACTS';
export const GET_RULES = 'GET_RULES';
export const CREATE_CONTRACT = 'CREATE_CONTRACT';
export const MOD_CONTRACT = 'MOD_CONTRACT';
export const DELETE_CONTRACT = 'DELETE_CONTRACT';
export const RESET_CONTRACT_SELECTED = 'RESET_CONTRACT_SELECTED';
export const RESET_CONTRACT_VARIANT_SELECTED = 'RESET_CONTRACT_VARIANT_SELECTED';
export const ADD_CONTRACT_MODE = 'ADD_CONTRACT_MODE';
export const EDIT_CONTRACT_MODE = 'EDIT_CONTRACT_MODE';
export const CHECK_ADD_CONTRACT_MODE_PERMIT = 'CHECK_ADD_CONTRACT_MODE_PERMIT';
export const DELETE_CONTRACT_MODE = 'DELETE_CONTRACT_MODE';
export const CLEAR_CONTRACTS = 'CLEAR_CONTRACTS';
export const HANDLE_CONTRACTS_INPUTS = 'HANDLE_CONTRACTS_INPUTS';

const INITIAL_STATE = {
  contractSelected: null,
  contractVariantSelected: null,
  rulesObj: {},
  rulesArr: [],
  contractsObj: {},
  contractsArr: [],
  activeContractVariantsObj: {},
  activeContractVariantsArr: [],
  addContract: true,
  addMode: false,
  deleteMode: false,
  station: null,
}

export const contractsCatalogReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

    case ADD_CONTRACT_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_CONTRACT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_CONTRACT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CHECK_ADD_CONTRACT_MODE_PERMIT:
      return {
        ...state,
        addContract: action.payload,
      }

    case GET_RULES:
      return {
        ...state,
        rulesObj: convertToObjById(action.payload),
        rulesArr: action.payload,
      }

    case GET_CONTRACTS:
      const filteredContracts = action.payload.filter(contract => contract?.name.length > 0).map(contract => {
        return {
          ...contract,
          variantsNum: contract.variants.length,
          value: contract.id
        }
      });

      const listContracts = convertToObjById(filteredContracts);
      return {
        ...state,
        contractsObj: listContracts,
        contractsArr: filteredContracts,
      }

    case CONTRACT_SELECTED:
      const contract = action.payload && state.contractsObj[action.payload]
      const contractVariantWithValue = contract.variants.map(variant => ({...variant, value: variant.id}))
      return {
        ...state,
        contractSelected: contract,
        activeContractVariantsArr: contractVariantWithValue,
        activeContractVariantsObj: convertToObjById(contractVariantWithValue, 'id')
      }

    case CONTRACT_VARIANT_SELECTED:
      const contractVariant = action.payload && state.activeContractVariantsObj[action.payload]
      return {
        ...state,
        contractVariantSelected: contractVariant,
      }

    case RESET_CONTRACT_SELECTED:
      return {
        ...state,
        contractSelected: null,
        activeContractVariantsArr: [],
        activeContractVariantsObj: {},
        contractVariantSelected: null,
      }

    case RESET_CONTRACT_VARIANT_SELECTED:
      return {
        ...state,
        contractVariantSelected: null,
      }

    case CREATE_CONTRACT:
      const addingContract = [{...action.payload, variantsNum: action.payload.variants.length}, ...state.contractsArr]
      const newContracts = convertToObjById(addingContract)
      return {
        ...state,
        contractsObj: newContracts,
        contractsArr: addingContract
      }

    case MOD_CONTRACT:
      const editedContracts = {
        ...state.contractsObj,
        [action.payload.id]: {
          ...state.contractsObj[action.payload.id],
          ...action.payload
        },
      }
      return {
        ...state,
        contractsObj: editedContracts,
        contractsArr: convertToMapById(editedContracts)
      }

    case DELETE_CONTRACT:
      const dataArray = state.contractsArr.filter(contract => contract.id !== action.payload)
      return {
        ...state,
        contractsObj: convertToObjById(dataArray),
        contractsArr: dataArray
      }

    case CLEAR_CONTRACTS:
      return {
          ...state,
          ...INITIAL_STATE,
      };

    case HANDLE_CONTRACTS_INPUTS:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    default :
      return state
  }
}